export const BIO_INTRO =
  'I\'m Laith (rhymes with "faith") Al-Saadoon, a Principal AI Engineer in AWS Developer Tools. I build tools that help AI agents work longer without human intervention, and make their work easier to inspect, verify, and improve.'

export const PROFILE_UPDATED = "2026-09-11"

export const BIO_WORK =
  "At AWS, I help coding assistants build well on our platform. I work with customers and the teams building those assistants, turn what we learn into open-source tools and reference implementations, and bring the gaps back to engineering."

export const AWS_WORK = [
  {
    role: "Tech lead",
    name: "Agent Toolkit for AWS",
    href: "https://github.com/aws/agent-toolkit-for-aws"
  },
  { role: "Creator", name: "AWS MCP Servers", href: "https://github.com/awslabs/mcp" }
] as const
